<template>
  <BuildingSectionCard
    title="Lease term"
    tone="secondary"
    :hint="unitDefaultHint"
    :form="LeaseTermsForm"
    :has-info="Boolean(terms.length)"
    :placeholder="{
      title: 'No default lease term yet',
      subtitle: 'New units start with no lease term until you set a default.',
      buttonText: 'Add lease term',
    }"
  >
    <template v-if="terms.length" #subtitle>
      <DefaultDriftLine :building-id="building.id" :differing-ids="building.defaultsDrift?.leaseTerm" :units="units" />
    </template>

    <PropertyDetailsCardRows>
      <PropertyDetailsCardInfoItem label="Lease terms" icon="calendar-check-01" :value="terms.join(', ')" />
    </PropertyDetailsCardRows>
  </BuildingSectionCard>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { BuildingDto, LeaseTermsForm, PropertyListItemDto } from '@tallo/investor/property';
import { PropertyDetailsCardInfoItem, PropertyDetailsCardRows } from '@tallo/property';

import BuildingSectionCard from '../../../components/building-section-card.vue';
import DefaultDriftLine from '../default-drift-line.vue';
import { unitDefaultHint } from './unit-default.const';

/** The lease terms a new unit offers to start with; when a unit becomes available is the unit's own */
const props = defineProps<{ building: BuildingDto; units: PropertyListItemDto[] }>();

const terms = computed(() => props.building.leaseConditions?.possibleLeaseTerms ?? []);
</script>
